/* Dependencies */
import { matchSortFromUrl } from '../matchSort/matchSort';

// Models
export interface DecodeUrlParamsObj {
  filters: {
    [key: string]: string[];
  };
  sort: string;
}

/**
 * Decode the URL Params
 */
export const decodeURLParams = (): DecodeUrlParamsObj => {
  let searchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(searchParams as any);

  const keys = Object.keys(params).filter((key) => key !== 'sort');

  const filtersToReturn: { [key: string]: string[] } = {};
  keys.forEach((key) => {
    filtersToReturn[key] = params[key].split(',');
  });

  return {
    sort: matchSortFromUrl(params.sort),
    filters: filtersToReturn,
  };
};
